import React from "react";
import { useTranslation } from "react-i18next";
import { CompanyGig, PaymentMethod } from "model/Gig";
import { FontFamily, FontSize } from "config/font";
import { Text } from "components/Typography/text.styled";
import { RecruitFormData } from "./gigFormModal.component";
import { Column } from "./createGigModal.styled";
import { SimpleRow } from "../../organizationalStructure/organizationalStructure.styled";
import { RadioButton } from "../../general/radioButton/radioButton.component";

type Props = {
  gigData?: CompanyGig;
  isClone?: boolean;
  haveSimflexityPay: Boolean;
  setFormData: React.Dispatch<React.SetStateAction<RecruitFormData>>;
  formData: RecruitFormData;
};

export const GigPaymentType: React.FC<Props> = (props) => {
  const { t } = useTranslation();

  const updatePaymentType = (paymentType: PaymentMethod) => {
    props.setFormData({
      ...props.formData,
      paymentType,
    });
  };

  return (
    <Column>
      <Text
        fontFamily={FontFamily.MontserratRegular}
        fontSize={FontSize.Standard}
        style={{ marginBottom: 0 }}
      >
        {t("GigsCompany.PaymentMethod")}
      </Text>
      <SimpleRow style={{ marginTop: 5, marginBottom: 0 }}>
        <div style={{ marginRight: 15 }}>
          <RadioButton
            label={t("SimflexityPay.SimflexityPay")}
            value={PaymentMethod.SIMFLEXITY_PAY}
            checked={
              props.formData.paymentType === PaymentMethod.SIMFLEXITY_PAY
            }
            onChange={() => updatePaymentType(PaymentMethod.SIMFLEXITY_PAY)}
            name={PaymentMethod.SIMFLEXITY_PAY}
          />
        </div>
        <RadioButton
          label={t("GigsCompany.OwnSalaryProcessing")}
          value={PaymentMethod.NONE}
          checked={props.formData.paymentType === PaymentMethod.NONE}
          onChange={() => updatePaymentType(PaymentMethod.NONE)}
          name={PaymentMethod.NONE}
        />
      </SimpleRow>
    </Column>
  );
};
